import { RootState } from 'store/rootReducer';

export const selectGetCustomersAccount = (state: RootState) => state.customers.account.getCustomersAccountState;
export const selectUpdateCustomerById = (state: RootState) => state.customers.account.updateCustomerByIdState;
